import styled from 'styled-components'
import LiveModal from 'live/components/ui/Modal'

export const LocalDivisor = styled.div`
    width: calc(100% + 44px);
    margin-left: -22px;
    height: 2px;
    background: var(--gray-300);
    margin-top: 5px;
    margin-bottom: 22px;
`

export const ModalTitle = styled(LiveModal.Title)`
    line-height: 25px;
    min-height: 45px;
    padding: 10px 0;
    height: unset;
`

export const ModalHeader = styled(LiveModal.Header)`
    min-height: 45px;
    height: unset;
`

export const LiveModalWrapper = styled(LiveModal)`
    display: flex !important;
    .modal-dialog {
        margin: auto;
        max-width: 434px;
        height: 204px;
    }

    .modal-header {
        position: relative;
        display: flex;
        align-items: center;

        .fa-times {
            position: absolute;
            right: 24px;

            cursor: pointer;

            font-size: 14px;
            color: var(--gray-800);

            transition: all 0.2s ease-in-out;

            &:hover {
                opacity: 0.6;
            }
        }
    }

    .modal-body {
        padding: 31px 25px;
        span {
            font-size: 13px;
            line-height: 16px;
        }
    }

    .modal-footer {
        padding: 8px 25px;
    }
`

